import declare from "dojo/_base/declare";
import StringRen from "csi/heading/String";
import html from "csi/html";
import comm from "csi/comm";

const CompanyCustomFontFileMap = declare(StringRen, {

	/**
	 * @override
	 * Render font preview
	 */
	toHtmlStatic: function(ctx, h, refNode, actionData) {
		html.clear(refNode);

		const node = ctx.getNode();
		const fileMap = node.FileMap;
		for (const file in fileMap) {
			html.create("a", {
				href: comm.getFileHref(fileMap[file]),
				innerText: file,
			}, refNode);
			html.create("br", {}, refNode);
		}

		return true;
	},

});

export = CompanyCustomFontFileMap;